var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg card-sub-card",attrs:{"flat":""}},[_c('div',{staticClass:"card-title mb-4"},[(_vm.number)?_c('div',{staticClass:"circle"},[_vm._v(_vm._s(_vm.number))]):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }